import {
  ModalLayout,
  Pagination,
  SearchFilters,
  Table,
} from "@wac-ui-dashboard/wac_component_library";
import React from "react";
import { FaSort } from "react-icons/fa";
import useStoreList from "./useStoreList";
import EmptyData from "../../../Global/EmptyData";
import { ImageCard } from "../../../Global/ImageCard";
import OrderColumn from "../../../Global/OrderColumn";

const StoreList = () => {
  const {
    isLoading,
    isFetching,
    imageData,
    showEditModal,
    showImageModal,
    storeListingList,
    paginationOptions,
    storeListingState,
    handleEditColumnsClick,
    updateStoreListingFields,
    handlePagination,
    handleClearClick,
    closeImageModal,
    handlePageSize,
    handleSearch,
    handleSort,
    refetch,
    getRow,
  } = useStoreList();
  return (
    <>
      <div className="col-auto pro-pt-3 pro-pb-6">
        <SearchFilters
          onSearchInput={handleSearch}
          loading={isLoading}
          SearchIcon={
            <span className="material-symbols-outlined"> search </span>
          }
          showClearFilters={storeListingState?.search === "" ? false : true}
          handleClear={handleClearClick}
          searchInputProps={{ value: storeListingState?.search }}
          showActions={true}
          handleActionClick={handleEditColumnsClick}
        />
        {storeListingList?.data?.result?.length === 0 ? (
          <EmptyData />
        ) : (
          <Table
            multiSelect={false}
            data={storeListingList?.data?.result || []}
            uniqueID={"id"}
            fields={storeListingList?.data?.fields || []}
            SortIcon={<FaSort />}
            editIcon={<span className="material-symbols-outlined">edit</span>}
            handleSort={handleSort}
            getRow={getRow}
            loading={isFetching}
            clear={storeListingState?.clearSelection}
            perpage={storeListingState?.currentPageSize}
            assignable={false}
            deletable={false}
            editable={false}
            showCheckBox={false}
          />
        )}
        <ModalLayout
          show={showEditModal}
          handleClose={handleEditColumnsClick}
          backdrop="static"
        >
          <div className="pro-m-5">
            <OrderColumn
              title={"Choose which columns you see"}
              refetchData={refetch}
              tableFields={storeListingList?.data?.fields || []}
              moduleId={storeListingList?.data?.module_id}
              updateData={updateStoreListingFields}
            />
          </div>
        </ModalLayout>

        {storeListingList?.data?.result?.length > 0 && (
          <Pagination
            currentPage={storeListingState?.currentPage}
            totalPageCount={Math.ceil(
              storeListingList.data.total_count /
                storeListingState.currentPageSize
            )}
            defaultValue={paginationOptions?.filter(
              (item) => item?.value === storeListingState?.currentPageSize
            )}
            onPageChange={handlePagination}
            options={paginationOptions}
            onActionChange={handlePageSize}
            center
          />
        )}
        <ModalLayout
          show={showImageModal}
          handleClose={closeImageModal}
          backdrop="static"
        >
          <ImageCard data={imageData} handleClose={closeImageModal} />
        </ModalLayout>
      </div>
    </>
  );
};

export default StoreList;
